export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";